module.exports = __webpack_public_path__ + "img/目标8.bf72d621.png";